module.exports = __webpack_public_path__ + "img/history-about.d26dc365.png";